const jobOpenings = [
  {
    id: 1,
    role: "Manual Toll Free Systems",
    href: "#",
    description:
      "Back in the day, when not everyone had dial phones, they came up with Manual Toll-Free Systems. These systems needed operators to help out with setting up Toll-Free Numbers for businesses in the USA.The Zenith Number Service showed up first in the 1950s in the United States and Canada. Callers would talk to an operator and ask for a Toll-Free Number by saying things like Freephone or Zenith, followed by a specific number. Later on, automated systems took over from these manual setups, but some of those old-school manual Toll-Free Numbers kept being used alongside the new stuff. With the manual systems, operators would find the right area code and get the call going, and the charges were adjusted accordingly. Zenith numbers usually matched up with certain areas, and local phone books had these numbers listed for places where folks were cool with getting paid for taking incoming calls. Eventually, they phased out those manual Toll-Free Systems when the automated Toll-Free Services came in.",
    // salary: "$75,000 USD",
    // location: "San Francisco, CA",
  },
  {
    id: 2,
    role: "Initial Direct Dial Systems",
    href: "#",
    description:
      "Back in the late 1960s, AT&T came up with an automated Toll-Free Service in the United States. This was meant to replace the old way of needing an operator for collect calls and those manual Toll-Free Systems. With this new system, folks could just dial toll-free numbers themselves within a certain area. Instead of talking to an operator, they could just punch in 1-800 followed by seven more numbers to get connected to where they wanted to go. But, this setup had its limits. It couldn't do stuff like automatically figuring out who was calling or keeping a detailed record of calls. People had to get these pricey lines with a fixed rate, and they came with a bunch of hours for inbound calls in a specific area. The early version of this system wasn't as fancy as the modern Toll-Free Numbers we know now. Calls all went to one central place, so making toll-free calls to other countries wasn't doable. This service was mostly for big players like hotel chains, airlines, and car rental companies because it needed special connections and worked on this kind of all-you-can-call plan. Smaller local businesses with fewer long-distance calls didn't find it as budget-friendly. So, those early Direct-Dial Systems were a big step forward in toll-free talking, making things easier and cheaper for certain types of businesses.",
    // salary: "$125,000 USD",
    // location: "San Francisco, CA",
  },
];

const faqs = [
  {
    id: 1,
    answer:
      "In Canada, Toll-Free Numbers use the US SMS/800 database. Calls from landline phones don't cost anything, but cell phone calls might have charges depending on your Service Provider.",
  },
  {
    id: 2,
    answer:
      "In Australia, Toll-Free Numbers start with 1800 and then have six more digits. If you dial numbers that start with 1300 or 13, you might have to pay a fixed fee, usually like what you'd pay for a local call.",
  },
  {
    id: 3,
    answer:
      "In Japan, Toll-Free Numbers start with 0120 and 0800. People often call these free dial or Free Call Numbers. Other phone companies also give out Toll-Free Services with their own brand prefixes, like 0077.",
  },
  {
    id: 4,
    answer:
      "In the United Kingdom, the current Free Phone Numbers begin with 0800 or 0808, followed by seven numbers. There used to be shorter 0800 Numbers, and those still exist, but the older 0500 Free Phone Numbers stopped being used on June 5, 2017.",
  },
  // More questions...
];

export default function TollFreeNumber() {
  return (
    <div className="bg-white py-10">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto flex max-w-2xl flex-col items-end justify-between gap-16 lg:mx-0 lg:max-w-none lg:flex-row">
          <div className="w-full lg:max-w-lg lg:flex-auto">
            <h2 className="text-pretty text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
              The Evolution of Toll Free Numbers: Free, Easy, and Global Calling
            </h2>
            <p className="mt-6 text-xl/8 text-gray-600">
              A Toll-Free Number, often referred to as a free number, lets
              callers make calls without any charge. These numbers are
              recognized by a special prefix that works like an area code, and
              they give you access to specific services. Keep in mind that the
              services available might differ from country to country. The key
              difference from regular phone numbers is that making calls to
              Toll-Free Numbers from a landline won't cost the caller anything.
            </p>
            <img
              alt=""
              src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1344&h=1104&q=80"
              className="mt-16 aspect-[6/5] w-full rounded-2xl bg-gray-50 object-cover lg:aspect-auto lg:h-[34.5rem]"
            />
            <div className="w-full lg:max-w-xl lg:flex-auto py-10">
              <h3 className="sr-only">Job openings</h3>
              <ul className="-my-8 divide-y divide-gray-100">
                <li className="py-8">
                  <dl className="relative flex flex-wrap gap-x-3">
                    <dt className="sr-only">Role</dt>
                    <dd className="w-full flex-none text-lg font-semibold tracking-tight text-gray-900">
                      <a>
                        Vanity Numbers
                        <span aria-hidden="true" className="absolute inset-0" />
                      </a>
                    </dd>
                    <dt className="sr-only">Description</dt>
                    <dd className="mt-2 w-full flex-none text-base/7 text-gray-600">
                      A Vanity Phone Number, also known as a custom Toll-Free
                      Number or mnemonic, is a special Phone Number that spells
                      out a word or has a pattern that's easy to recognize.
                      These numbers are like gold in the world of business
                      advertising because they're easy to remember and work as
                      branding and direct response strategies. The Federal
                      Communications Commission (FCC) made some rules that say
                      the first ones to ask get to use vanity Toll-Free Numbers
                      in the United States. This means companies that are set up
                      as RespOrgs (Responsible Organizations) have an advantage
                      in grabbing the best word-based numbers. These RespOrgs
                      can snag recently unused numbers and new Toll-Free area
                      codes. In Australia, the normal numbers and the special
                      ones like the 13-series or Vanity Phone words are handed
                      out in different ways. Usually, the really good numbers
                      are sold in separate auctions. Buying one of these Vanity
                      Toll-Free Numbers is a big deal for businesses because
                      it's like a supercharged marketing tool. They make cool
                      phone numbers that people remember and that make the brand
                      stand out. Businesses can use these special numbers to
                      make their ads better and to get more people responding.
                      It's like a valuable thing that helps companies be more
                      noticeable and memorable to their customers.
                    </dd>
                  </dl>
                </li>
              </ul>
              <div className="mt-8 flex border-t border-gray-100 pt-8">
                <a
                  href="#"
                  className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                >
                  Contact Us <span aria-hidden="true">&rarr;</span>
                </a>
              </div>
            </div>
          </div>
          <div className="w-full lg:max-w-xl lg:flex-auto">
            <h3 className="sr-only">Job openings</h3>
            <ul className="-my-8 divide-y divide-gray-100">
              {jobOpenings.map((opening) => (
                <li key={opening.id} className="py-8">
                  <dl className="relative flex flex-wrap gap-x-3">
                    <dt className="sr-only">Role</dt>
                    <dd className="w-full flex-none text-lg font-semibold tracking-tight text-gray-900">
                      <a href={opening.href}>
                        {opening.role}
                        <span aria-hidden="true" className="absolute inset-0" />
                      </a>
                    </dd>
                    <dt className="sr-only">Description</dt>
                    <dd className="mt-2 w-full flex-none text-base/7 text-gray-600">
                      {opening.description}
                    </dd>
                  </dl>
                </li>
              ))}
              <img
                alt=""
                src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1344&h=1104&q=80"
                className="mt-16 aspect-[6/5] w-full rounded-2xl bg-gray-50 object-cover lg:aspect-auto lg:h-[34.5rem]"
              />
            </ul>
          </div>
        </div>
      </div>
      {/* section */}

      <div className="bg-white">
        <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24 lg:px-8">
          <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Implementations On A Global Scale
          </h2>
          <p className="mt-6 max-w-2xl text-base/7 text-gray-600">
            Toll-Free Calling is a thing in lots of countries, and it happens by
            setting aside special phone numbers called Toll-Free 800 Numbers.
            People can dial these numbers without worrying about getting
            charged. Check out these examples:
          </p>
          <div className="mt-20">
            <dl className="space-y-16 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-16 sm:space-y-0 lg:gap-x-10">
              {faqs.map((faq) => (
                <div key={faq.id}>
                  {/* <dt className="text-base/7 font-semibold text-gray-900">
                    {faq.question}
                  </dt> */}
                  <dd className="mt-2 text-base/7 text-gray-600">
                    {faq.answer}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>

      {/* section */}
      <div className="flex flex-col md:flex-row items-center justify-between p-6 ">
        {/* Left Content */}
        <div className="md:w-1/2 p-4">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Toll Free Australia
          </h1>
          <ul className="list-disc list-inside text-gray-600 space-y-2">
            <li>
              In Australia, they use Ten-digit Numbers that start with "1800"
              for their Toll-Free Numbers.
            </li>
            <li>
              These numbers let callers make calls without any charges. They
              also have something called Phonewords, which are numbers that
              spell out words, and you can get them through online auctions for
              the 1800 Numbers.
            </li>
            <li>
              If you're calling from a regular home phone line, there's no extra
              fee for dialing an 1800 Number. But if you're calling from a
              mobile phone, there might be charges depending on your Service
              Provider.
            </li>
            <li>
              In the beginning, Toll-Free Numbers in Australia had the prefix
              "800," and they had nine numbers in total. You could even call
              these numbers from outside Australia by adding the right
              international code.
            </li>
            <li>
              So, just to sum up, the original prefix was 800, and these numbers
              had nine digits. Like, the Toll-Free Number for Crime Stoppers was
              008 333 000, and sometimes people wrote it like (008) 33 3000,
              even though that's not exactly right. And, if you wanted, you
              could call numbers like +61 08 333 0000 from outside Australia.
            </li>
          </ul>
        </div>

        {/* Right Image */}
        <div className="md:w-1/2 p-4">
          <img
            src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1344&h=1104&q=80"
            alt="Placeholder"
            className="rounded-lg shadow-lg"
          />
        </div>
      </div>

      {/* Section */}

      <div className="flex items-center  p-6 md:p-12">
        {/* Left Content */}
        <div className="w-full md:w-full">
          <h2 className="text-3xl font-bold mb-4 text-gray-800">
            Local Rate Numbers
          </h2>
          <p className="text-lg text-gray-600 mb-4">
            In Australia, people can dial numbers that have either 6 or 10
            digits and start with the prefixes 13, 1300, or 1301. These numbers
            usually have local call rates.
          </p>
          <ul className="list-disc list-inside text-gray-600 space-y-2">
            <li>
              Sometimes, there might be a "connection fee" for calling a 13
              Number.
            </li>
            <li>
              These numbers are often set up to connect you to businesses close
              to where you are.
            </li>
            <li>
              You can keep the same 13, 1300, or 1800 Number even if you change
              your Telecom Provider in Australia.
            </li>
            <li>
              The ACMA might sell special numbers that have letters on the
              keypad through an auction.
            </li>
            <li>
              When you call 1300 or 1800 Numbers from a cell phone, you might
              have to pay, but there are usually other regular phone numbers you
              can call instead.
            </li>
            <li>
              Some really cleverly set up 1800 or 13(00) numbers might not work
              when you're using a mobile phone.
            </li>
            <li>
              Every now and then, really smartly set up 1800 or 13(00) Numbers
              might not work with mobile devices because the folks who own them
              might stop calls from those devices. That's usually because these
              calls can cost more, and the owners want to avoid that.
            </li>
          </ul>
        </div>
      </div>

      {/* section */}

      <div className="flex flex-col md:flex-row items-center justify-between p-6">
        {/* Left Side: Image */}
        <div className="md:w-1/2 w-full flex justify-center">
          <img
            src="https://www.knotnetworks.com/images/Toll%20free%20Number%20Canada%20-%20Knot%20Networks%20LLC.jpg"
            alt="Sample"
            className="rounded-lg shadow-lg max-w-full h-auto"
          />
        </div>

        {/* Right Side: Content */}
        <div className="md:w-1/2 w-full text-center md:text-left p-6">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Canada Toll Free Number
          </h1>
          <p className="text-lg text-gray-600">
            NANP Toll-Free Numbers don't cost anything if you're calling from a
            regular phone at home, but if you're using a cell phone or a
            payphone, there might be charges. In Canada, you can dial 310
            numbers and pay local rates for something called a shared-cost
            service. They've also got special numbers that are only for mobile
            phones, and they're used for specific things. For instance, you can
            dial *CAA to get in touch with the Canadian Automobile Association
            without any charge.
          </p>
        </div>
      </div>

      <div className="flex items-center  p-6 md:p-12">
        {/* Left Content */}
        <div className="w-full md:w-full">
          <h2 className="text-3xl font-bold mb-4 text-gray-800">
            Toll Free United Kingdom
          </h2>
          <p className="text-lg text-gray-600 mb-4">
            Toll-Free Phone Numbers in the UK are called "Free Phone" Numbers.
            They start with either 0800 or 0808 as their first numbers. Starting
            from July 1, 2015, you don't have to pay when you call these numbers
            from landlines or mobile phones. They stopped using the 0500 range
            for new numbers. The 0800 numbers can have either six or seven
            digits, while the 0808 Numbers always have seven digits. There are
            certain numbers, like those in the 08081 570xxx range, that can't be
            used because they might be fake Phone Numbers.
          </p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center justify-between p-6 md:p-12 min-h-screen">
        {/* Left Content */}
        <div className="md:w-1/2 text-center md:text-left">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Best Toll Free Numbers Provider in United States
          </h1>
          <p className="text-lg text-gray-600">
            In the United States, you can get Toll-Free Numbers from different
            companies. These numbers start with prefixes like 800, 888, 877,
            866, 855, 844, and 833. These prefixes have been around since
            different times, starting from January 1, 1966. Some area codes are
            saved for later use, like 822, 880-887, and 889. The Wide Area
            Telephone Service (WATS) isn't used anymore. Toll Free Numbers in
            North America are managed by the SMS/800 database. You can route
            these numbers to any regular phone number controlled by a RespOrg
            (Responsible Organization). Service providers set up gateways to
            take Toll-Free calls and send them to voice-over IP or pager
            customers. You can also do things like direct inward dialing and
            keep your US Toll-Free Number even if you change providers. They use
            automatic number identification to keep track of billing, even if
            the caller's ID isn't shown.
          </p>
        </div>

        {/* Right Image */}
        <div className="md:w-1/2 mt-6 md:mt-0 flex justify-center">
          <img
            src="	https://www.knotnetworks.com/images/Toll%20free%20Number%20Australia%20-%20Knot%20Networks%20LLC.jpg"
            alt="Descriptive Alt Text"
            className="rounded-lg shadow-lg w-full md:w-3/4"
          />
        </div>
      </div>

      <div className="flex items-center  p-6 md:p-12">
        {/* Left Content */}
        <div className="w-full md:w-full">
          <h2 className="text-3xl font-bold mb-4 text-gray-800">
            International Free Phone Service Available Worldwide
          </h2>
          <ul className="list-disc list-inside text-gray-600 space-y-2">
            <li>
              The International Telecommunication Union (ITU) set up something
              called the Universal International Free Phone Service, which is an
              International Toll Free Service Provider that uses the country
              code 800. With this, people all around the world can call a
              company that's subscribed to this service without having to pay.
              But, only a few countries are part of this, and they need to agree
              on how to handle the costs for network transmission and
              subscriptions.
            </li>
            <li>
              If you have a "800 Number" that the ITU gives you, it's called a
              Universal International Free Phone Number (UIFN). If you use this
              number, the person making the call doesn't get charged, but the
              person or business getting the call has to pay. It's kind of like
              how the 800 area code works in the US and Canada, or like the 0800
              numbers in other countries. To dial a UIFN, you need to use the
              international access code (IAC), then the UIFN country code (800),
              and then the 8-digit UIFN. The number has to be available for
              incoming calls from at least two different country codes for 180
              days.
            </li>
            <li>
              The ITU also looks after two special codes that don't tie to a
              specific place: the +808 Universal International Shared Cost
              Number (UISCN) and the +979 Universal International Premium Rate
              Number (UIPRN). Both have eight digits, but the UIPRN has one more
              digit that shows how much it costs. And that UIPRN number comes
              with a high premium cost.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
